import React from 'react';

export const HeartFilledIcon = () => (
    <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-foreground"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.42026 1.64995C4.55055 0.633175 3.10023 0.359666 2.01053 1.29073C0.920837 2.22179 0.767423 3.77848 1.62317 4.87965C2.33466 5.79519 4.48789 7.72615 5.19361 8.35113C5.27256 8.42105 5.31204 8.45601 5.35809 8.46975C5.39828 8.48174 5.44225 8.48174 5.48244 8.46975C5.52849 8.45601 5.56797 8.42105 5.64692 8.35113C6.35263 7.72615 8.50586 5.79519 9.21736 4.87965C10.0731 3.77848 9.93842 2.21199 8.82999 1.29073C7.72156 0.369459 6.28998 0.633175 5.42026 1.64995Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.95"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const HeartOutlineIcon = () => (
    <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-foreground"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.42026 1.64995C4.55055 0.633175 3.10023 0.359666 2.01053 1.29073C0.920837 2.22179 0.767423 3.77848 1.62317 4.87965C2.33466 5.79519 4.48789 7.72615 5.19361 8.35113C5.27256 8.42105 5.31204 8.45601 5.35809 8.46975C5.39828 8.48174 5.44225 8.48174 5.48244 8.46975C5.52849 8.45601 5.56797 8.42105 5.64692 8.35113C6.35263 7.72615 8.50586 5.79519 9.21736 4.87965C10.0731 3.77848 9.93842 2.21199 8.82999 1.29073C7.72156 0.369459 6.28998 0.633175 5.42026 1.64995Z"
            fill="transparent"
            stroke="currentColor"
            strokeWidth="0.95"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);


type PlaybackIconProps = {
    className?: string;
    color?: string;
    hovered?: boolean;
    style?: React.CSSProperties;
};

export const PlayIcon = ({ className = 'text-white', color = 'currentColor', hovered, style }: PlaybackIconProps) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const shouldGrow = hovered ?? isHovered;

    return (
        <svg
            className={className}
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                transform: `translateX(-1px) scale(${shouldGrow ? 1.1 : 1})`,
                transition: 'transform 100ms ease',
                ...style,
            }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.71186 13.7012C6.34021 13.9475 5.95729 13.9648 5.57437 13.7539C5.19146 13.543 5 13.2268 5 12.804V4.09646C5 3.67367 5.19146 3.35739 5.57437 3.14653C5.95729 2.9346 6.34021 2.95289 6.71186 3.19925L13.5593 7.57882C13.8859 7.79075 14.0548 8.08122 14.0548 8.45022C14.0548 8.81921 13.8859 9.10968 13.5593 9.32054L6.71186 13.7012Z"
                fill={color}
            />
        </svg>
    );
};

export const StopIcon = ({ className = 'text-white', color = 'currentColor', hovered, style }: PlaybackIconProps) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const shouldGrow = hovered ?? isHovered;

    return (
        <svg
            className={className}
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                transform: `scale(${shouldGrow ? 1.1 : 1})`,
                transition: 'transform 100ms ease',
                ...style,
            }}
        >
            <rect x="3" y="3" width="11" height="11" rx="2" fill={color} />
        </svg>
    );
};

export const AddToCartIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.9">
            <path d="M5.6 11.2L11.7041 10.6913C13.614 10.5322 14.0428 10.115 14.2544 8.21024L14.7 4.20001" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" />
            <path d="M4.2 4.20001H4.55M15.4 4.20001H13.65" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" />
            <path d="M6.65 4.2H11.55M9.1 6.65V1.75" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" />
            <path d="M4.19999 15.3996C4.97319 15.3996 5.59999 14.7728 5.59999 13.9996C5.59999 13.2264 4.97319 12.5996 4.19999 12.5996C3.42679 12.5996 2.79999 13.2264 2.79999 13.9996C2.79999 14.7728 3.42679 15.3996 4.19999 15.3996Z" stroke="currentColor" stroke-width="1.05" />
            <path d="M11.9 15.3996C12.6732 15.3996 13.3 14.7728 13.3 13.9996C13.3 13.2264 12.6732 12.5996 11.9 12.5996C11.1268 12.5996 10.5 13.2264 10.5 13.9996C10.5 14.7728 11.1268 15.3996 11.9 15.3996Z" stroke="currentColor" stroke-width="1.05" />
            <path d="M5.6 14H10.5" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" />
            <path d="M1.40002 1.40039H2.07622C2.7375 1.40039 3.31392 1.8376 3.47431 2.46084L5.55699 10.5539C5.66223 10.963 5.57216 11.3962 5.31179 11.7335L4.64252 12.6004" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" />
        </g>
    </svg>

);

export const RemoveFromCartIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.6 11.2L11.7041 10.6913C13.614 10.5322 14.0428 10.115 14.2544 8.21024L14.7 4.20001" stroke="#404040" stroke-width="1.05" stroke-linecap="round" />
        <path d="M15.4 4.19998L14.7605 4.17567" stroke="#404040" stroke-width="1.05" stroke-linecap="round" />
        <path d="M7.23779 4.20017L9.48456 5.49734L11.5436 1.93102" stroke="#2A2A2A" stroke-width="1.05" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.19999 15.3996C4.97319 15.3996 5.59999 14.7728 5.59999 13.9996C5.59999 13.2264 4.97319 12.5996 4.19999 12.5996C3.42679 12.5996 2.79999 13.2264 2.79999 13.9996C2.79999 14.7728 3.42679 15.3996 4.19999 15.3996Z" stroke="#404040" stroke-width="1.05" />
        <path d="M11.9 15.3996C12.6732 15.3996 13.3 14.7728 13.3 13.9996C13.3 13.2264 12.6732 12.5996 11.9 12.5996C11.1268 12.5996 10.5 13.2264 10.5 13.9996C10.5 14.7728 11.1268 15.3996 11.9 15.3996Z" stroke="#404040" stroke-width="1.05" />
        <path d="M5.6 14H10.5" stroke="#404040" stroke-width="1.05" stroke-linecap="round" />
        <path d="M1.40002 1.40039H2.07622C2.7375 1.40039 3.31392 1.8376 3.47431 2.46084L5.55699 10.5539C5.66223 10.963 5.57216 11.3962 5.31179 11.7335L4.64252 12.6004" stroke="#404040" stroke-width="1.05" stroke-linecap="round" />
    </svg>

);

export const CartIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.45">
            <path d="M5.6 11.2L11.7041 10.6913C13.614 10.5322 14.0428 10.115 14.2544 8.21024L14.7 4.20001" stroke="#2A2A2A" stroke-width="1.05" stroke-linecap="round" />
            <path d="M4.2 4.20001H15.4" stroke="#2A2A2A" stroke-width="1.05" stroke-linecap="round" />
            <path d="M4.19999 15.3996C4.97319 15.3996 5.59999 14.7728 5.59999 13.9996C5.59999 13.2264 4.97319 12.5996 4.19999 12.5996C3.42679 12.5996 2.79999 13.2264 2.79999 13.9996C2.79999 14.7728 3.42679 15.3996 4.19999 15.3996Z" stroke="#2A2A2A" stroke-width="1.05" />
            <path d="M11.9 15.3996C12.6732 15.3996 13.3 14.7728 13.3 13.9996C13.3 13.2264 12.6732 12.5996 11.9 12.5996C11.1268 12.5996 10.5 13.2264 10.5 13.9996C10.5 14.7728 11.1268 15.3996 11.9 15.3996Z" stroke="#2A2A2A" stroke-width="1.05" />
            <path d="M5.6 14H10.5" stroke="#2A2A2A" stroke-width="1.05" stroke-linecap="round" />
            <path d="M1.40002 1.40039H2.07622C2.7375 1.40039 3.31392 1.8376 3.47431 2.46084L5.55699 10.5539C5.66223 10.963 5.57216 11.3962 5.31179 11.7335L4.64252 12.6004" stroke="#2A2A2A" stroke-width="1.05" stroke-linecap="round" />
        </g>
    </svg>

);

export const UserProfileIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
    </svg>
);

// --- Site header (redesign) — paths taken verbatim from design_handoff ---

// Shopping-bag glyph, 12×13 (solid fill, follows currentColor). `withDot`
// overlays the 5px alert-red badge at its top-right (shown when the cart has
// items).
export const CartBagIcon = ({ withDot = false }: { withDot?: boolean }) => (
    <span className="relative block w-3 h-[13px]">
        <svg viewBox="0 0 12 13" fill="none" className="block w-3 h-[13px]">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.99996 1.3C4.9282 1.3 4.05933 2.17305 4.05933 3.25H7.94061C7.94061 2.17305 7.07178 1.3 5.99996 1.3ZM2.76556 3.25C2.76556 1.45508 4.21367 0 5.99996 0C7.78633 0 9.23439 1.45508 9.23439 3.25H8.81009C9.09168 3.25003 9.33782 3.25084 9.54431 3.2669C9.77576 3.2849 10.0054 3.32459 10.2317 3.42958C10.5586 3.58125 10.8371 3.8213 11.036 4.12291C11.1737 4.33172 11.2476 4.5537 11.3005 4.78084C11.3503 4.99444 11.3901 5.25433 11.4358 5.55307L11.7275 7.45882C11.8522 8.27275 11.9522 8.92574 11.9866 9.45549C12.0219 9.99817 11.9946 10.4807 11.8179 10.9344C11.5513 11.6189 11.0616 12.1924 10.4289 12.5612C10.0094 12.8057 9.539 12.9061 8.99989 12.9537C8.47358 13 7.81602 13 6.99655 13H5.00343C4.18394 13 3.5264 13 3.00012 12.9537C2.46096 12.9061 1.99054 12.8057 1.57113 12.5612C0.938331 12.1924 0.448658 11.6189 0.182069 10.9344C0.00537917 10.4807 -0.0218741 9.99817 0.0133811 9.45549C0.047789 8.9258 0.147778 8.27275 0.272394 7.45888L0.564198 5.55305C0.609926 5.25433 0.649703 4.99444 0.699449 4.78084C0.752351 4.5537 0.826296 4.33172 0.963992 4.12291C1.16288 3.8213 1.44136 3.58125 1.76827 3.42958C1.9946 3.32459 2.22419 3.2849 2.45566 3.2669C2.66217 3.25084 2.90832 3.25003 3.18989 3.25H2.76556Z"
                fill="currentColor"
            />
        </svg>
        {withDot && (
            <span className="absolute left-[9px] -top-[2px] h-[5px] w-[5px] rounded-full bg-alert" />
        )}
    </span>
);

// Circle-avatar glyph, 20×20. Two-tone: warm-grey disc + a figure in
// currentColor (the header sets it to ink-secondary, matching the cart glyph).
export const AccountAvatarIcon = () => (
    <svg viewBox="0 0 20 20" fill="none" className="block w-5 h-5">
        <path d="M10 20C15.5228 20 20 15.5229 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20Z" fill="#CBC8C4" />
        <path d="M10 4.92969C7.93 4.92969 6.25 6.60969 6.25 8.67965C6.25 10.7097 7.84 12.3597 9.95 12.4197C9.98 12.4197 10.02 12.4197 10.04 12.4197C10.06 12.4197 10.09 12.4197 10.11 12.4197C10.12 12.4197 10.13 12.4197 10.13 12.4197C12.15 12.3497 13.74 10.7097 13.75 8.67965C13.75 6.60969 12.07 4.92969 10 4.92969Z" fill="currentColor" />
        <path d="M16.7807 17.3505C15.0007 18.9905 12.6207 20.0005 10.0007 20.0005C7.3807 20.0005 5.0007 18.9905 3.2207 17.3505C3.4607 16.4405 4.1107 15.6105 5.0607 14.9705C7.7907 13.1505 12.2307 13.1505 14.9407 14.9705C15.9007 15.6105 16.5407 16.4405 16.7807 17.3505Z" fill="currentColor" />
    </svg>
);

// Cart "remove item" control — a 30px grey disc with a black bin glyph.
export const PackRemoveIcon = () => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" className="block">
        <rect width="30" height="30" rx="15" fill="#EFEFEF" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4 10.2H20.4C20.7314 10.2 21 10.4686 21 10.8C21 11.1314 20.7314 11.4 20.4 11.4H9.6C9.26863 11.4 9 11.1314 9 10.8C9 10.4686 9.26863 10.2 9.6 10.2H12.6V9.6C12.6 9.26863 12.8686 9 13.2 9H16.8C17.1314 9 17.4 9.26863 17.4 9.6V10.2ZM10.2 12.6L11.253 19.9698C11.3375 20.561 11.8438 21 12.441 21H17.559C18.1562 21 18.6625 20.561 18.747 19.9698L19.8 12.6H10.2Z"
            fill="black"
        />
    </svg>
);
